import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 配置路由
  {
    path: "/",
    component: () => import("../views/wxH5/parkingPay.vue"),
    meta: {
      keepAlive: true // 判断是否缓存
    }
  },
  //  支付成功页面 - 西安银行支付宝成功地址配置
  {
    path: "/successPage",
    name: "successPage",
    component: () => import("../views/wxH5/successPage.vue")
  },
  //  支付成功页面
  {
    path: "/successPay",
    name: "successPay",
    component: () => import("../views/wxH5/successPay.vue")
  },
  //  跳转重定向链接-无牌码
  {
    path: "/unCardRuleH5",
    name: "pay",
    component: () => import("../views/wxH5/redirectUrlNullPlate.vue")
  },
  //  跳转重定向链接-包月
  {
    path: "/monthlyInfoH5",
    name: "pay",
    component: () => import("../views/wxH5/redirectUrlMonthly.vue")
  },
  //  跳转重定向链接-预支付
  {
    path: "/parkingPayH5",
    name: "pay",
    // component: () => import("../views/wxH5/redirectUrl.vue")
    component: () => import("../views/wxH5/redirectUrlScan.vue") // 旧
  },
  //  跳转重定向链接-出口缴费
  {
    path: "/preParkingPayH5",
    name: "pay",
    // component: () => import("../views/wxH5/redirectUrlScan.vue")
    component: () => import("../views/wxH5/redirectUrl.vue") // 旧
  },
  // 微信公众号-出口缴费
  {
    path: "/scanPay",
    name: "pay",
    component: () => import("../views/wxH5/scanPay.vue")
  },
  // 微信公众号-预约缴费
  {
    path: "/parkingPay",
    name: "pay",
    component: () => import("../views/wxH5/parkingPay.vue")
  },

  //  TODO: 2026-09-9 18:00:00  新增云端缴费路由配置,已确认路由地址
  //  跳转重定向链接-云端出口缴费
  {
    path: "/cloudParkingPayH5",
    name: "cloudPay",
    component: () => import("../views/cloudParking/redirectUrlScanPay.vue") // 默认先进入云端出口重定向页面
  },
  // 重定向跳转至云端出口缴费页面
  {
    path: "/cloudScanPayH5",
    name: "scanPayH5",
    component: () => import("../views/cloudParking/scanPay.vue") // 出口扫码缴费提交页面
  },
  //  跳转重定向链接-云端预支付缴费
  {
    path: "/cloudPreParkingPayH5",
    name: "cloudPrePay",
    component: () => import("../views/cloudParking/redirectUrlParkingPay.vue") // 默认先进入云端预支付重定向页面
  },
  // 重定向跳转至云端预支付缴费页面
  {
    path: "/cloudParkingPay",
    name: "parkingPayH5",
    component: () => import("../views/cloudParking/parkingPay.vue") // 预支付扫码缴费提交页面
  },
  //  跳转重定向链接-云端包月缴费
  {
    path: "/cloudMonthlyInfoH5",
    name: "cloudMonthlyPay",
    component: () => import("../views/cloudParking/redirectUrlMonthly.vue") // 默认先进入云端包月重定向页面
  },
  // 重定向跳转至云端包月缴费页面
  {
    path: "/cloudMonthlyPayH5",
    name: "cloudMonthlyH5",
    component: () => import("../views/cloudParking/monthly.vue") // 包月提交页面
  },
  //  跳转重定向链接-云端无牌车缴费
  {
    path: "/cloudUnCardRuleH5",
    name: "cloudNullPlatePay",
    component: () => import("../views/cloudParking/redirectUrlNullPlate.vue") // 默认先进入云端无牌车重定向页面
  },
  // 重定向跳转至云端无牌车缴费页面
  {
    path: "/cloudNullPlatePayH5",
    name: "cloudNullPlateH5",
    component: () => import("../views/cloudParking/nullPlate.vue") // 无牌车提交页面
  },

  // 车牌号领取
  {
    path: "/receiveCoupon",
    name: "receiveCoupon",
    component: () => import("../views/receiveCoupon/index.vue")
  },
  // 发票信息填写页面
  {
    path: "/invoiceSearch",
    name: "invoiceSearch",
    component: () => import("../views/invoice/openInvoice.vue")
  },
  //   填写发票抬头信息
  {
    path: "/writeInvoice/:id",
    component: () => import("../views/invoice/writeInvoice.vue")
  },
  {
    path: "/QRcode/:id/:merchartID",
    component: () => import("../views/scanQR/index.vue")
  },
  {
    path: "/Monthly",
    component: () => import("../views/wxH5/monthly.vue")
  },
  {
    path: "/nullPlate",
    component: () => import("../views/wxH5/nullPlate.vue")
  },
  {
    path: "/authorization",
    component: () => import("../views/wxH5/authorization.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
